import React, { useState } from "react";
import SearchControls from "./SearchControls";
import FilterPanel from "./FilterPanel";
import BothyList from "./BothyList";
import SectionCard from "../ui/SectionCard";

const BothyBrowser = ({
  bothies,
  allBothiesCount,
  searchValue,
  showFilters,
  filters,
  visibleBothiesCount,
  availableBothyFeatures,
  availableBortleClasses,
  naturalFeatureOptions,
  weatherDayOptions,
  weatherUnits,
  weatherRanges,
  onSearchChange,
  onBothyFeatureToggle,
  onNaturalFeatureToggle,
  onElevationChange,
  onRoadDistanceChange,
  onBortleClassChange,
  onWeatherFilterChange,
  onClearFilters,
  onToggleFilters,
  onSelectBothy
}) => (
  <div className="browser">
    <SearchControls searchValue={searchValue} onSearchChange={onSearchChange} />

    <FilterPanel
      showFilters={showFilters}
      filters={filters}
      availableBothyFeatures={availableBothyFeatures}
      availableBortleClasses={availableBortleClasses}
      naturalFeatureOptions={naturalFeatureOptions}
      weatherDayOptions={weatherDayOptions}
      weatherUnits={weatherUnits}
      weatherRanges={weatherRanges}
      visibleBothiesCount={visibleBothiesCount}
      allBothiesCount={allBothiesCount}
      onBothyFeatureToggle={onBothyFeatureToggle}
      onNaturalFeatureToggle={onNaturalFeatureToggle}
      onElevationChange={onElevationChange}
      onRoadDistanceChange={onRoadDistanceChange}
      onBortleClassChange={onBortleClassChange}
      onWeatherFilterChange={onWeatherFilterChange}
      onClearFilters={onClearFilters}
      onToggleFilters={onToggleFilters}
    />

    <ResultsSection
      bothies={bothies}
      onSelectBothy={onSelectBothy}
      visibleBothiesCount={visibleBothiesCount}
      allBothiesCount={allBothiesCount}
    />
  </div>
);

const ResultsSection = ({
  bothies,
  onSelectBothy,
  visibleBothiesCount,
  allBothiesCount
}) => {
  const [open, setOpen] = useState(false);

  return (
    <SectionCard
      title="Results"
      description="Visible bothies"
      collapsible
      open={open}
      onToggle={() => setOpen(prev => !prev)}
      actions={
        <span className="pill pill--border">
          {visibleBothiesCount} / {allBothiesCount}
        </span>
      }
    >
      <BothyList bothies={bothies} onSelect={onSelectBothy} />
    </SectionCard>
  );
};

export default BothyBrowser;
